import moment from 'moment';

module.exports = {
  filters: {
    formatDate (value) {
      return moment(value).format('ddd, MMMM Do')
    }
  }
}


// WEBPACK FOOTER //
// ./src/js/pickup/mixins/filter-formatDate.js